module.exports = "/images/earthquake@3x.png?39b73076f828f286c10ff577ab53a505";